$('#slick-About').slick({
  infinite: true,
  fade: true,
  dots: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000
});

$('#slick-post-Mob').slick({
  infinite: true,
  dots: true,
  arrows: false,
});